import { ConfigSchema, ConfigSchemaInput, configSchema } from './configSchema';

export const createConfig = (config: ConfigSchemaInput): ConfigSchema => configSchema.parse(config);
